import { XMLFormat } from './XMLFormat.mjs';

class XMLStringFormat {
  static test(data) {
    if (typeof data === "string" && data.includes("<font>")) {
      const xml = new globalThis.DOMParser().parseFromString(data, "text/xml");
      return XMLFormat.test(xml);
    }
    return false;
  }
  static parse(xmlTxt) {
    const xml = new globalThis.DOMParser().parseFromString(xmlTxt, "text/xml");
    return XMLFormat.parse(xml);
  }
}

export { XMLStringFormat };
//# sourceMappingURL=XMLStringFormat.mjs.map
